import React from 'react';
import { Link } from 'gatsby';
import Container from 'common/source/components/UI/Container';
import Box from 'reusecore/src/elements/Box';
import Image from 'reusecore/src/elements/Image';
// import { UncontrolledTooltip } from 'reactstrap';
import SolarPanelMono36 from './img/mono-36.png';
import SolarPanelMono54 from './img/mono-54.png';
import SolarPanelMono72 from './img/mono-72.png';
import SecLogo from './img/sec.png';
import { PanelsBlockWrapper, SolarPanelsShowRoom } from './solar.styles';

const PanelsPromoMono = () => {
  return (
    <PanelsBlockWrapper>
      <Container>
        <Box className="row centered">
          <Box className="col info">
            <div className="product-line-title">
              <div className="heading">Energía Solar</div>
              <h3>
                Paneles Solares <br />
                <span>Certificados</span>
                <br />
                Monocristalinos
              </h3>
            </div>
            <div className="subheading-img">
              <Image
                className="img-fluid"
                style={{ width: '25%', padding: 0, margin: 0 }}
                src={SecLogo}
                alt="UpSolar Paneles Solares"
              />
            </div>

            <div className="product-line-info">
              <p>
                Gran Variedad de Paneles Solares Monocristalinos de 36, 54, 60 y
                72 celdas <strong>(10W-330W)</strong> para uso industrial y
                particular, aplicaciones Off-Grid y On-Grid (conectado a la
                red), con
                <strong> certificación SEC</strong> para generación eléctrica
                residencial
                <strong> (140W-330W)</strong>.
              </p>
            </div>
            <div>
              <Link to="/product/panel-solar-mono-small">Menos de 90W</Link>
              {' | '}
              <Link to="/product/panel-solar-mono-medium">100W a 240W</Link>
              {' | '}
              <Link to="/product/panel-solar-mono-large">250W a 330W</Link>
            </div>
          </Box>

          <Box className="col flex-end">
            <SolarPanelsShowRoom>
              <ul className="sp-showroom-pv">
                <li>
                  <span>
                    {/* <UncontrolledTooltip placement="top" target="sp-pv-mono-small">
                  Menos de <strong>90W</strong>
                </UncontrolledTooltip> */}

                    <Link to="/product/panel-solar-mono-small">
                      <Image
                        className="img-fluid mono-36"
                        src={SolarPanelMono36}
                        alt="UpSolar Paneles Solares monocristalino pequeño"
                        id="sp-pv-mono-small"
                      />
                    </Link>
                  </span>
                </li>
                <li>
                  <span>
                    {/* <UncontrolledTooltip placement="top" target="sp-pv-mono-medium">
                  De <strong>100W</strong> a <strong>240W</strong>
                </UncontrolledTooltip> */}

                    <Link to="/product/panel-solar-mono-medium">
                      <Image
                        className="img-fluid mono-54"
                        src={SolarPanelMono54}
                        alt="UpSolar Paneles Solares monocristalino mediano"
                        id="sp-pv-mono-medium"
                      />
                    </Link>
                  </span>
                </li>
                <li>
                  <span>
                    {/* <UncontrolledTooltip placement="top" target="sp-pv-mono-lg">
                  De <strong>250W</strong> a <strong>330W</strong>
                </UncontrolledTooltip> */}
                    <Link to="/product/panel-solar-mono-large">
                      <Image
                        className="img-fluid mono-72"
                        src={SolarPanelMono72}
                        alt="UpSolar Paneles Solares monocristalino grande"
                        id="sp-pv-mono-lg"
                      />
                    </Link>
                  </span>
                </li>
              </ul>
            </SolarPanelsShowRoom>
          </Box>
        </Box>
      </Container>
    </PanelsBlockWrapper>
  );
};

export default PanelsPromoMono;
